import { appEntry } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full">
            <span className="inline-block px-4 py-1.5 bg-accent-100/80 text-accent-700 text-xs font-semibold rounded-full mb-4">
              移动入口
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-4">
              {appEntry.title}
            </h2>
            <p className="text-base text-foreground-500 mb-6 leading-relaxed">
              {appEntry.description}
            </p>

            <div className="grid grid-cols-2 gap-3 mb-8">
              {appEntry.features.map((feat) => (
                <div key={feat} className="flex items-center gap-2 text-sm text-foreground-600">
                  <div className="w-6 h-6 flex items-center justify-center bg-accent-100 rounded-full flex-shrink-0">
                    <i className="ri-check-line text-accent-600 text-xs"></i>
                  </div>
                  {feat}
                </div>
              ))}
            </div>

            <button className="inline-flex items-center gap-2 px-8 py-3.5 bg-accent-500 text-background-50 font-semibold rounded-lg hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer text-sm">
              <i className="ri-smartphone-line text-lg"></i>
              添加到主屏幕
            </button>
          </div>

          <div className="flex-1 w-full flex justify-center">
            <div className="relative w-60 h-[420px] bg-background-900 rounded-[2.5rem] border-4 border-background-800 p-3 shadow-2xl">
              <div className="w-full h-6 flex justify-center">
                <div className="w-20 h-1.5 bg-background-700 rounded-full mt-2"></div>
              </div>
              <div className="w-full h-full bg-background-50 rounded-[2rem] overflow-hidden mt-2">
                <div className="p-4 space-y-3">
                  <div className="w-full h-8 bg-primary-500 rounded-lg flex items-center justify-center">
                    <span className="text-xs font-bold text-background-50">爆料网</span>
                  </div>
                  <div className="space-y-2">
                    <div className="w-full h-3 bg-background-200 rounded"></div>
                    <div className="w-3/4 h-3 bg-background-200 rounded"></div>
                  </div>
                  <div className="w-full h-28 bg-primary-50 rounded-lg flex items-center justify-center">
                    <span className="text-xs text-primary-500 font-semibold">🔥 最新黑料速览</span>
                  </div>
                  <div className="space-y-2">
                    <div className="w-full h-2 bg-background-200 rounded"></div>
                    <div className="w-4/5 h-2 bg-background-200 rounded"></div>
                    <div className="w-3/5 h-2 bg-background-200 rounded"></div>
                  </div>
                  <div className="w-full h-20 bg-accent-50 rounded-lg flex items-center justify-center">
                    <span className="text-xs text-accent-600 font-semibold">📱 移动端专属视图</span>
                  </div>
                  <div className="space-y-2">
                    <div className="w-full h-2 bg-background-200 rounded"></div>
                    <div className="w-5/6 h-2 bg-background-200 rounded"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}